import _ from 'lodash';
import { Router, RouterLink } from '@angular/router';
import { Component, OnInit, signal } from '@angular/core';
import { CompaniesService } from './../../services/companies.service';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  imports: [
    MatToolbar,
    MatToolbarRow,
    FlexLayoutModule,
    FaIconComponent,
    MatIcon,
    MatIconButton,
    RouterLink,
    MatProgressSpinner,
    NgIf,
    NgForOf,
  ],
  styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
  public srcLogo: string = '../../../assets/image/new-logo-long_IDS.png';
  faPhoneSquareAlt = faPhoneSquare;
  public data: any = [];
  public isLoading = signal(false);

  constructor(
    private router: Router,
    private companiesService: CompaniesService
  ) {}

  ngOnInit() {
    this.onGetPackage();
  }

  onGetPackage() {
    this.isLoading.set(true);
    this.companiesService.getPackages().subscribe(
      rs => {
        this.isLoading.set(false);
        if (rs && rs['$values']) {
          _.forEach(rs['$values'], o => {
            this.data.push({
              Id: o.Package_Id,
              Name_Plan: o.Package_Name,
              Price: o.Price,
              Price_Sale: o.Price_Sale,
              Number_User: o.Max_User,
              Benefit: o.Benefit.split(','),
              Plan_Id: o.Plan_Id,
            });
          });

          console.log(this.data);
        }
      },
      err => {
        this.isLoading.set(false);
        console.log(err);
      }
    );
  }

  navigateTo(id: number, name: string) {
    if (name == 'Advanced') {
      window.location.href = 'https://www.restoreunited.com/contact-us/';
    } else {
      this.router.navigateByUrl(`/signup/${id}`);
    }
  }

  openNav() {
    document.getElementById('wrapperOver').style.display = 'block';
    document.body.style.position = 'relative';
    document.body.style.left = '-300px';
    document.getElementById('mySidenav').style.width = '300px';
    document.getElementById('main').style.marginRight = '300px';
    document.body.style.backgroundColor = 'rgba(255,255,255,.95)';
    document.body.style.boxShadow =
      'rgba(0, 0, 0, 0.15) -1px 0px 20px 4px inset';
  }

  closeNav() {
    document.getElementById('wrapperOver').style.display = 'none';
    document.body.style.position = 'relative';
    document.body.style.left = '0px';
    document.getElementById('mySidenav').style.width = '0';
    document.getElementById('main').style.marginRight = '0';
    document.body.style.backgroundColor = '#fff';
    document.body.style.boxShadow = 'none';
  }
}
